// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 18) return "static/js/1f801b2e69a0f87c1716.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"c4b6670a73b6ab7b7f32","126":"0301e10cb1e4749b9ff7","127":"3ed2b8c5e89578ce6cd9"}[chunkId] + ".chunk.js";
};